import React from 'react';
import { createRoot } from 'react-dom/client'; // Per React 18
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './style.css';

// Istanza del QueryClient
const queryClient = new QueryClient();

// Seleziona l'elemento root
const container = document.getElementById('root');

// Inizializza il createRoot
const root = createRoot(container);

// Renderizza l'applicazione
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
